<template>
    <div class="bg-white bar" v-if="pageMenuList.length > 0">
        <mvtShifter type="2">
            <div :class="item.selected ? 'active' : ''" v-for="(item,index) in pageMenuList">
                <a class="link-style singleline" :data-ga-event="item.gaEvent" :href="item.url">{{item.text}}</a>
            </div>
        </mvtShifter>
    </div>
    <nav class="nav fixed fixed-max-sm inline bg-transparent" v-if="breadCrumb.length">
        <ul class="crumbs mvt-breadcrumb">
            <li v-for="(crumb, index) in breadCrumb">
                <span v-if="!crumb.url">{{crumb.text}}</span>
                <a v-else :href="crumb.url" :title="crumb.text" v-ga:click>{{crumb.text}}</a>
            </li>
        </ul>
    </nav>
</template>

<script src="./mvt-pagemenu.js"></script>